import React from 'react';
import DocumentBrowser from '../components/documents/DocumentBrowser';

const HUB_PATH = '/documents';
const IN_PROGRESS_PATH = '/documents/in-progress';

const DocumentsInProgress = () => (
  <DocumentBrowser
    scope="documents"
    status="in-progress"
    showFilters
    showPending
    returnTo={IN_PROGRESS_PATH}
    completedReturnTo={HUB_PATH}
    inProgressReturnTo={IN_PROGRESS_PATH}
    placeholder="Search in progress"
    emptyText="No documents in progress."
  />
);

export default DocumentsInProgress;
